import { IAddress } from "../contractors/IAddress"
import { IContact } from "./IContact"
import { IServiceTier } from "./IServiceTier"

export interface ICustomer {
    Id: string,
    Created: string,
    Name: string,
    Type: CustomerType,
    Status: number,
    WebSite: string | null,
    WebPortal: string | null,
    ManagerId: string,
    DefaultContactId: string,
    send_confirmation: boolean,
    requires_order_number: boolean,
    is_vat: boolean,
    is_cis: boolean,
    reverse_charge_type: number,
    reverse_charge_notice_received: boolean,
    vat_number: string | null,
    DefaultContact: IContact | null,
    ServiceTier: IServiceTier | null,
    HeadOffice: {
        Address: IAddress
    },
    Billing: {
        Address: IAddress,
        ContactId: string,
        Contact: IContact
    },
    product_restriction_id: string | null,
    defaults: {
        default_nte: number
    }
}

export enum CustomerType { Domestic = 0, PrivateBusiness = 50, PublicSector = 60, Premium = 100}